<template>
    <div class="h-100">
        <b-navbar v-if="isMobile" class="main-navbar" fixed="top" style="width: 100%">
            <b-navbar-nav style="width: 100%">
                <b-nav-item style="margin-left: 0; width: 33%">
                    <!-- the burger menu icon which is hidden until it has a function
                <img src="./assets/icon_menu.svg" style="height: 30px; float: left; margin-top: 10px;">
                -->
                </b-nav-item>

                <b-nav-item style="width: 33%">
                    <img
                        alt="cybo-logo"
                        style="width: 100px; margin-top: 5px"
                        :src="this.$icons.cyboLogoBlue"
                    />
                </b-nav-item>

                <b-nav-item style="width: 33%">
                    <!-- the user login button which is hidden until it has a function
                <img src="./assets/icon_logged_out.svg" alt="" style="width: 40px; float: right; margin-top: 5px;">
                -->
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>

        <b-navbar
            v-else
            id="navbar-desktop"
            class="main-navbar"
            type="light"
            variant="light"
            fixed="top"
        >
            <b-navbar-brand style="margin-top: 5px">
                <img style="height: 40px" :src="this.$icons.cyboLogoDark1" alt="cybo" />
            </b-navbar-brand>

            <!-- the navbar items which are hidden until they have a function
            <b-navbar-nav class="ml-auto">

                <b-nav-item-dropdown :text="currentLanguage.toUpperCase()" right>
                    <b-dropdown-item v-for="lang in languages" :key="lang.title" @click="changeLanguage(lang.language)">
                        <flag :iso="lang.flag" v-bind:squared=false style="margin-right: 10px;"/>
                        <a>{{ lang.title }}</a>
                    </b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item>
                    <img src="./assets/icon_logged_out.svg" alt="" width="30px">
                </b-nav-item>

            </b-navbar-nav>
            -->
        </b-navbar>

        <div class="h-100" style="margin-top: 60px">
            <MobilePageCyboDark1
                v-if="isMobile"
                :pathToPng="pathToPng"
                :mainState="mainState"
                @triggerDownloadImage="downloadImage"
                @triggerDownloadPdf="downloadPdf"
                @triggerDeleteBon="deleteBon"
            >
            </MobilePageCyboDark1>

            <DesktopPageCyboDark1
                v-else
                :pathToPng="pathToPng"
                :mainState="mainState"
                @triggerDownloadImage="downloadImage"
                @triggerDownloadPdf="downloadPdf"
                @triggerDeleteBon="deleteBon"
            ></DesktopPageCyboDark1>
        </div>
    </div>
</template>

<script>
    import DesktopPageCyboDark1 from './DesktopPageCyboDark1'
    import MobilePageCyboDark1 from './MobilePageCyboDark1'

    export default {
        name: 'ContainerCyboDark1',
        data() {
            return {}
        },
        methods: {
            downloadImage: function () {
                window.open(this.$payload.HOSTNAME + '/download/png/' + this.hashcode, '_self')
            },
            downloadPdf: function () {
                window.open(this.$payload.HOSTNAME + '/download/pdf/' + this.hashcode, '_self')
            },
            deleteBon: function () {
                let context = this
                this.$http
                    .get(this.$payload.HOSTNAME + '/unlinkBon?bonid=' + this.hashcode)
                    .then(function (response) {
                        console.log('ok deleted bon')
                        console.log(response)
                    })
                    .catch(function (err) {
                        console.log('error while deleting bon')
                        console.log(err)
                    })
                    .finally(function () {
                        context.mainState = 100
                    })
            }
        },
        components: {
            MobilePageCyboDark1,
            DesktopPageCyboDark1
        },
        props: {
            hashcode: String,
            mainState: Number,
            isMobile: Boolean,
            pathToPng: String
        }
    }
</script>

<style scoped>
    .main-navbar {
        margin: 0;
        height: 60px;
        color: #002e62 !important;
        background: #ffffff;
        box-shadow: 0px 1.34483px 1.34483px #4d4d4d;
    }
    .nav-item {
        margin-left: 40px;
    }
    .nav-item:hover {
        text-decoration: underline;
    }
    .navbar-light .navbar-nav .nav-link {
        color: white !important;
    }

    #navbar-desktop {
        background-color: #0f110c !important;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
</style>